import React from 'react'

import EditableItemFooter from './EditableItemFooter'
import OwnBookingFooter from './OwnBookingFooter'
import ReadOnlyItemFooter from './ReadOnlyItemFooter'

import { useAppSelector } from 'hooks/reduxHooks'
import { getCurrentUserId } from 'selectors/accountSelectors'
import type { AccommodationItem } from 'tripPlanner/types/tripItem'
import { getOrderId, isLeBooking } from 'tripPlanner/utils'

interface Props {
  item: AccommodationItem
}

export default function AccommodationSummaryModalFooter({ item }: Props) {
  const orderId = getOrderId(item)
  const userId = useAppSelector(getCurrentUserId)

  if (isLeBooking(item) && orderId) {
    if (item.createdBy === userId) {
      return <OwnBookingFooter item={item} orderId={orderId} />
    } else {
      return <ReadOnlyItemFooter item={item} />
    }
  } else {
    return <EditableItemFooter item={item} />
  }
}
